import React from 'react';
import { Helmet } from 'react-helmet-async';
import useWpSeoMeta from '../hooks/useWpSeoMeta';

function SeoMetaTags({ slug, defaultTitle, defaultDescription }) {
  const seoData = useWpSeoMeta(slug);
  
  // Use WordPress SEO data if available, otherwise fall back to defaults
  const title = seoData?.title || defaultTitle || 'Page';
  const description = seoData?.metaDesc || defaultDescription || '';
  
  return (
    <Helmet>
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      
      {/* Open Graph tags */}
      {(seoData?.opengraph?.title || title) && (
        <meta property="og:title" content={seoData?.opengraph?.title || title} />
      )}
      {(seoData?.opengraph?.description || description) && (
        <meta property="og:description" content={seoData?.opengraph?.description || description} />
      )}
      {seoData?.opengraph?.image && (
        <meta property="og:image" content={seoData.opengraph.image} />
      )}
      {seoData?.opengraph?.type && (
        <meta property="og:type" content={seoData.opengraph.type} />
      )}
      
      {/* Twitter Card tags */}
      {seoData?.twitter?.card && (
        <meta name="twitter:card" content={seoData.twitter.card} />
      )}
      {(seoData?.twitter?.title || title) && (
        <meta name="twitter:title" content={seoData?.twitter?.title || title} />
      )}
      {(seoData?.twitter?.description || description) && (
        <meta name="twitter:description" content={seoData?.twitter?.description || description} />
      )}
      {seoData?.twitter?.image && (
        <meta name="twitter:image" content={seoData.twitter.image} />
      )}
      
      {/* Canonical URL */}
      {seoData?.canonical && (
        <link rel="canonical" href={seoData.canonical} />
      )}
      
      {/* Robots meta */}
      {seoData?.robots && (
        <meta name="robots" content={seoData.robots} />
      )}
    </Helmet>
  );
}

export default SeoMetaTags;
